<template>
  <div class="block">
    <el-date-picker
      v-model="valuePicker"
      type="daterange"
      range-separator="по"
      start-placeholder="Начало"
      end-placeholder="Конец"
    />
  </div>
</template>

<script>
export default {
  name: 'DatePicker',
  data() {
    return {
      valuePicker: '',
    }
  },
  watch: {
    valuePicker(newVal) {
      this.$emit('pickedDate', newVal)
    },
  },
}
</script>
